import { render } from "./FeedbackExport.vue?vue&type=template&id=42477869"
import script from "./FeedbackExport.vue?vue&type=script&lang=js"
export * from "./FeedbackExport.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__